import { useState } from "react";

import { parseQueryString, parseAmplifyConfig } from "@warden-ui/common";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CardContentTeamDomain } from "@warden-ui/card-components";
import { CupixWorksApi } from "@warden-ui/api";
import { cloneSearchParams } from "@warden-ui/common";
import { Region } from "@warden-ui/common";
import { CupixWorksDomainPostfix } from "@warden-ui/common";
import { CPPageBody } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

const defaultQueryString: {[key: string]: string} = {
  config: "",
  region: "",
  skip_contact: "false",
}

export default function TeamDomain() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = parseAmplifyConfig(queryString);

  const [teamDomainPostfix, setTeamDomainPostfix] = useState(CupixWorksDomainPostfix(amplifyConfig[amplifyConfig.region]?.cupixworksApiEndpoint));
  const [region, setRegion] = useState(amplifyConfig.region);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const onClickFindTeamDomain = async (teamDomain: string) => {
    const cupixWorksApiEndpoint = amplifyConfig[region]?.cupixworksApiEndpoint;
    if (!cupixWorksApiEndpoint) {
      setErrorMessage(t('errors.config_cupixworks_api_endpoint'))
      return;
    }

    const domainFormat = /^[a-zA-Z0-9-]+$/;
    if (!domainFormat.test(teamDomain)) {
      setErrorMessage(t('errors.team_not_found'));
      return;
    }

    setLoading(true);
    new CupixWorksApi(cupixWorksApiEndpoint)
      .findTeamByDomain(teamDomain)
      .then((data) => {
        const params = cloneSearchParams(searchParams);
        params.set("team_domain", data.domain);
        params.set("region", region);

        navigate(`/?${params.toString()}`);
      })
      .catch((error) => {
        setErrorMessage(t('errors.team_not_found'));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRegionChanged = (newRegion: Region) => {
    setRegion(newRegion);
    setTeamDomainPostfix(
      CupixWorksDomainPostfix(amplifyConfig[newRegion]?.cupixworksApiEndpoint)
    );
  };

  const onClickFindTeamDomainLink = async () => {
    navigate(`/teams/find?${searchParams.toString()}`);
  };

  const onClickContactLink = async () => {
    window.open('https://www.cupix.com/contact-sales', '_blank');
  };

  return (
    <CPPageBody
      regions={amplifyConfig.regions}
      defaultRegion={amplifyConfig.region}
      showRegion={amplifyConfig.regions.length > 1}
      onRegionChanged={onRegionChanged}
      onBackClicked={queryString.team_domain ? () => navigate(-1) : undefined}
    >
      <CardContentTeamDomain
        teamDomain={queryString.team_domain}
        teamDomainPostfix={teamDomainPostfix}
        showContact={!queryString.skip_contact}
        onClickFindTeamDomain={onClickFindTeamDomain}
        onClickFindTeamDomainLink={onClickFindTeamDomainLink}
        onClickContactLink={onClickContactLink}
        errorMessage={errorMessage}
        loading={loading}
      />
    </CPPageBody>
  );
}
